import React from 'react'
import styled, { css } from 'styled-components'
import { useStore } from 'effector-react'
import { Column, Row } from '../components/layout'
import { PrimitiveLink } from '../components/link'
import PLANS, { IPlan } from '../plans'
import Plan from '../components/plan'
import OptionalService from '../components/optional-service'
import store, { setState$ } from '../store'
import {
  title1,
  onMobile,
  onTablet,
  touchable,
  subbody,
  body,
} from '../utils/selector'
import Svg from '../components/svg'
import { changeError$ } from './store'
import Indicator from './indicator'
import Picker from './picker'

export default function PackageList() {
  const { plan, type, state } = useStore(store)
  const index = PLANS.map(v => v.value).indexOf(plan)

  const onChange = (plan: IPlan) => () => setState$({ plan: plan.value })

  const onClick = (e: React.MouseEvent) => {
    if ([type, state].every(v => v)) return

    e.preventDefault()
    window.location.href = '#picker'
    changeError$(true)
  }

  const onPlanChange = (diff: number) => () => {
    const newIndex = index + diff
    if (newIndex < 0 || newIndex > 2) return
    onChange(PLANS[newIndex])()
  }

  return (
    <Styled gutter={72}>
      <Title>我们为你推荐以下组合：</Title>

      <Picker />

      <Column gutter={16}>
        <Viewport>
          <Action
            onClick={onPlanChange(-1)}
            style={{
              opacity: index === 0 && 0,
            }}
          >
            <Svg name="left" />
          </Action>
          <InnerViewport>
            {PLANS.map((p, i) => (
              <Container
                key={p.name}
                className={p.value === plan ? 'active' : ''}
                onClick={onChange(p)}
              >
                <Plan {...p} index={i} withFilingFee />
              </Container>
            ))}
          </InnerViewport>
          <Action
            onClick={onPlanChange(1)}
            style={{ opacity: index === PLANS.length - 1 && 0 }}
          >
            <Svg name="right" />
          </Action>
        </Viewport>
        <Row
          alignment="center"
          innerStyle={css`
            ${onTablet} {
              display: none;
            }
          `}
        >
          <Indicator count={PLANS.length} current={index} />
        </Row>
      </Column>

      <OptionalService />

      <Row style={{ width: '100%', maxWidth: 917 }}>
        <Extra>
          *如果需要以下模板，请发送邮件至
          <a href="mailto:corplaw@ailaw.ai">corplaw@ailaw.ai</a>获取：
          <ul>
            <li>美国公司股东注册 （C-Corp)</li>
            <li>美国公司企业章程</li>
            <li>美国公司首年年审</li>
            <li>美国公司创始人股票购买协议</li>
            <li>美国公司员工保密协议</li>
            <li>美国公司员工手册</li>
            <li>美国公司员工雇佣合同</li>
          </ul>
        </Extra>
      </Row>

      <PrimitiveLink
        onClick={onClick}
        href={`/check-out?plan=${plan}&state=${state}&type=${type}&locale=cn`}
      >
        开始注册
      </PrimitiveLink>
    </Styled>
  )
}

const Styled = styled(Column)`
  ${onTablet} {
    align-items: center;
  }
`

const Title = styled.p`
  ${title1}
`

const Viewport = styled.div`
  display: flex;
  margin: unset 24px;
`

const InnerViewport = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  position: relative;
  margin: 0 16px;
`

const Container = styled.div`
  ${onTablet} {
    ${touchable}
  }

  box-sizing: border-box;
  padding: 56px 24px;
  flex: 1;
  flex-shrink: 0;

  &.active {
    display: block;
    width: 100%;
    border: 1px solid #045e99;
    box-sizing: border-box;
    border-radius: 32px;
  }

  ${onMobile} {
    display: none;
  }
`

const Action = styled.button`
  border: none;
  outline: none;
  background: transparent;

  ${onTablet} {
    display: none;
  }
`

const Extra = styled.div`
  ${body}

  > ul {
    ${subbody}
  }

  a {
    color: inherit;
    margin: 0 4px;
  }
`
